/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-04-09 09:19:12
 * @LastEditors: chen
 * @LastEditTime: 2021-04-09 09:21:10
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ticketLevel'
})
export class TicketLevelPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (Number(value) < 10) {
      return '0' + value.toString();
    }
    return value;
  }

}
